import React from 'react'
import PropTypes from 'prop-types'
import parse from 'html-react-parser'
import _ from 'lodash'
import {
    Row,
    Col,
    Container,
    Card,
} from 'react-bootstrap'
import { graphql } from 'gatsby'

import { ButtonAnalytics, Layout } from '../components/common'
import { MetaData } from '../components/common/meta'
import ContactUs from '../images/career/contactUs.svg'

/**
 * Main index page (home page)
 *
 * Loads all posts from Ghost and uses pagination to navigate through them.
 * The number of posts that should appear per page can be setup
 * in /utils/siteConfig.js under `postsPerPage`.
 *
 */

const Careers = ({ data, location }) => {
    const page = data.ghostPage || {}
    const position = data.allLever || {}
    const positions = position.edges

    const images = []
    const listMainTypes = {}
    positions.forEach((obj) => {
        const { node } = obj
        if (node?.categories?.team){
            if (!listMainTypes[node?.categories?.team]){
                listMainTypes[node?.categories?.team] = []
            }
            listMainTypes[node?.categories?.team].push({ ...node })
        }
    })

    console.log(_.map(listMainTypes, (positionsAll, index) => {
        console.log(index); return positionsAll
    }))

    parse(page.html, {
        replace: (domNode) => {
            if (domNode.name === 'img'){
                images.push(domNode.attribs.src)
            }
        },
    })

    return (
        <>
            <MetaData
                data={data}
                location={location}
                type="website"
            />
            <Layout>
                <section className="our-mission our-mission-career">
                    <Container>
                        <Row style={{ alignItems: 'center' }}>
                            <Col className="price-container">
                                {/*<span className="sub-title">Our Mission</span>*/}
                                <ContactUs className="contactUs" />
                                <h1>
                                    {page.title}
                                </h1>
                                <div className="general-content" style={{ maxWidth: '760px' }} dangerouslySetInnerHTML={{ __html: page.html }}></div>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <section className="careers">
                    <Container>
                        <Row style={{ textAlign: 'center' }}>
                            <Col>
                                <span className="sub-title">Open positions </span>
                                <div className="card-block">
                                    {_.map(listMainTypes, (positionsAll , indexMain) => (
                                        <div key={indexMain} className="careers-team">
                                            <h2>{indexMain}</h2>
                                            {positionsAll.map((node , index) => {
                                                const title = `${node.text} ${node.categories.location} ${node.categories.commitment}`
                                                const slug = title.toLowerCase()
                                                    .replace(/[^\w ]+/g,'')
                                                    .replace(/ +/g,'-')
                                                return (
                                                    <Card key={index}>
                                                        <Card.Body>
                                                            <Card.Title>{node.text}</Card.Title>
                                                            <div className="card-sub-title">
                                                                {node.categories.location} / {node.categories.commitment}
                                                            </div>
                                                        </Card.Body>
                                                        <Card.Footer>
                                                            <ButtonAnalytics
                                                                href={`/careers/${slug}`}
                                                                variant="primary"
                                                                size="lg"
                                                            >
                                                                Learn More
                                                            </ButtonAnalytics>
                                                        </Card.Footer>
                                                    </Card>
                                                )
                                            })}
                                        </div>

                                    ))}
                                </div>
                            </Col>

                        </Row>
                    </Container>
                </section>
            </Layout>
        </>
    )
}

Careers.propTypes = {
    data: PropTypes.shape({
        ghostPage: PropTypes.object.isRequired,
        allLever: PropTypes.object.isRequired,
    }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }).isRequired,
    pageContext: PropTypes.object,
}

export default Careers

// This page query loads all posts sorted descending by published date
// The `limit` and `skip` values are used for pagination
export const pageQuery = graphql`
  query CareersQuery($slug: String!) {
        ghostPage(slug: { eq: $slug }) {
            ...GhostPageFields
        }
        allLever {
            edges {
              node {
                descriptionPlain
                categories {
                  team
                  commitment
                  location
                }
                applyUrl
                text
              }
            }
        }
    }
`
